export type PointerMode = "laser" | "highlight" | "sketch" | "magnifier";

export type PointerModeOption = {
  mode: PointerMode;
  label: string;
  icon: string;
  activeClass: string;
};

type PointerModeBarProps = {
  options: PointerModeOption[];
  value: PointerMode;
  onSelect: (mode: PointerMode) => void;
};

export default function PointerModeBar({
  options,
  value,
  onSelect,
}: PointerModeBarProps) {
  return (
    <div className="flex gap-2">
      {options.map(({ mode, label, icon, activeClass }) => (
        <button
          key={mode}
          onClick={() => onSelect(mode)}
          className={`flex-1 flex items-center justify-center gap-1.5 rounded-xl font-medium transition-all cursor-pointer px-2 py-2 text-xs ${
            value === mode
              ? `${activeClass} text-white shadow-lg`
              : "bg-gray-100 text-gray-600 hover:bg-gray-200"
          }`}
        >
          <i className={`${icon} text-base`}></i>
          {label}
        </button>
      ))}
    </div>
  );
}
